import { TAsyncActionType } from "./types";

export const initialAsyncActionState: TAsyncActionType = {
  loading: false,
  success: false,
  successMessage: "",
};
